import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { Box, Button, Grid, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import useAPI from "../../../../../api/hooks/useAPI";
import useColors from "../../../../../api/hooks/useColors";
import { entityKeys } from "../../../../../api/queryKeys";
import { extractTypeFromEntityId } from "../../../controls/components/EntitiesSection/utils";
import { getStepRequestId } from "../../../steps/utils";
import ExecutionTypeContent from "./ExecutionTypeContent";
import NonExecutionTypeContent from "./NonExecutionTypeContent";

const ScenarioSetNodeToolTip = ({
  Icon,
  item,
  handleMoreInfoClick,
  handleEntityChipStepClick,
}) => {
  const step = item.nodeValue;

  let entity_ids =
    item.type !== "execution"
      ? step?.misconfigured_entity_ids
      : step?.entity_ids;
  if (step.cwe_id && item?.entity_type_filter) {
    entity_ids = entity_ids.filter(
      (entity_id) =>
        item.entity_type_filter === extractTypeFromEntityId(entity_id)
    );
  }

  const showViewStepButton = Boolean(
    step?.mitigating_controls_tools_set?.length ||
      step?.related_vulnerability_ids?.length ||
      step?.is_always_shown
  );

  const { fetchEntitiesBatch } = useAPI();
  const { data: complexMisconfiguredEntitiesByType } = useQuery({
    queryKey: entityKeys.entitiesByStep(step?.step_id),
    queryFn: async () => {
      const entities = (
        await fetchEntitiesBatch(
          entity_ids,
          getStepRequestId(step?.step_id, item?.entity_type_filter)
        )
      ).data;
      return entities;
    },
    select: (response) => {
      const entities = response;
      const entitiesByType = {};
      entities.forEach((entity) => {
        if (entity.entity_type in entitiesByType) {
          entitiesByType[entity.entity_type].push(entity);
        } else {
          entitiesByType[entity.entity_type] = [entity];
        }
      });
      return entitiesByType;
    },
    enabled: step !== null,
  });

  const colors = useColors();

  return (
    <Box
      sx={{
        padding: "8px",
        display: "flex",
        flexDirection: "column",
        width: "350px",
        overflow: "auto",
      }}
    >
      <Grid container alignItems={"center"} gap={2}>
        {item.type !== "execution" ? (
          <NonExecutionTypeContent
            step={step}
            fullNode={item}
            complexMisconfiguredEntitiesByType={
              complexMisconfiguredEntitiesByType
            }
            handleEntityChipStepClick={handleEntityChipStepClick}
          />
        ) : (
          <ExecutionTypeContent
            step={step}
            complexMisconfiguredEntitiesByType={
              complexMisconfiguredEntitiesByType
            }
          />
        )}
      </Grid>
      {showViewStepButton && (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button
            sx={{ textTransform: "none" }}
            onClick={() => handleMoreInfoClick(step.step_id)}
            endIcon={
              <ArrowForwardRoundedIcon sx={{ color: colors.primary_main }} />
            }
          >
            <Typography
              variant="caption"
              sx={{
                textTransform: "none",
                color: colors.primary_main,
              }}
            >
              View Step
            </Typography>
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default ScenarioSetNodeToolTip;
